export default __webpack_public_path__ + "static/media/addIcon.0c24cfda.svg";